export default (params) => ({
  trigger: {
    name: 'mini_product_page.select_color_alternative',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      item_id: {
        type: 'integer',
      },
    },
    event: {
      name: 'select_item',
      params: {
        sub_feature: 'color_collection',
        method: 'image',
      },
    },
    nonInt: true,
  },
});
